import axios from "axios";

const http = axios.create({
    baseURL: process.env.REACT_APP_ENV == 'development' ? require('../../package.json').homepage : '' // 动态域名 http://test.ads-goal.com
    // baseURL: ''
})



export default http;
